import { container } from 'inversify.config';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { IdentityService } from 'services/identity-service';
import { RequestFormStore, RequestFormViewModel } from 'stores/requests/request-form-store';
import TailwindLocationEditor, { LocationItemReference } from 'widgets/bussiness/location-editor-tw';
import TailwindInstructorEditor, { InstructorReference } from 'widgets/bussiness/request-instructor-editor-tw';

interface RequestInstructorContainerProp {
  request?: RequestFormViewModel;
  readOnly: boolean;
  requestFormStore?: RequestFormStore;
  onChange?: (value: Partial<RequestFormViewModel>) => void;
}

const RequestInstructorContainer: React.FC<RequestInstructorContainerProp> = ({ request, readOnly, requestFormStore, onChange }) => {
  const { t } = useTranslation();
  const identityService: IdentityService = container.get(IdentityService);

  const [selectedRequest /*, setSelectedRequest*/] = useState<RequestFormViewModel>(request);

  const { instructorLocation, instructor } = selectedRequest;

  const isPlannerTFT = () => {
    const userinfo = identityService.getUserInfo();
    return IdentityService.isPlannerTFT(userinfo);
  };

  const isPlannerMTC = () => {
    const userinfo = identityService.getUserInfo();
    return IdentityService.isPlannerMTC(userinfo);
  };

  const handleOnLocationChange = (newLocation: LocationItemReference) => {
    requestFormStore.change({
      instructorLocation: newLocation,
      instructor: null
    });
    onChange && onChange({ instructorLocation: newLocation });
  };

  const handleOnInstructorChange = (newInstructor: InstructorReference) => {
    requestFormStore.change({
      instructorLocation: newInstructor ? newInstructor.location : null,
      instructor: newInstructor
    });
    onChange && onChange({ instructor: newInstructor });
  };

  return (
    <div className="space-y-4 p-4">
      <div className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("Instructor's Location")}</label>
          <TailwindLocationEditor nullable clearable readOnly={readOnly} value={instructorLocation} onChange={handleOnLocationChange} />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("Instructor's Name")}</label>
          <TailwindInstructorEditor
            nullable
            clearable
            activeOnly
            readOnly={readOnly}
            role={'Instructor'}
            location={instructorLocation}
            value={instructor}
            onChange={handleOnInstructorChange}
            onlyInstructorsPlannerTFT={isPlannerTFT()}
            onlyInstructorsPlannerMTC={isPlannerMTC()}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(['requestFormStore', RequestFormStore])(RequestInstructorContainer);
